import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  Typography,
} from "@mui/material";


function PermissionModel(props) {
  const { open, handleClose, handleAgree, user, permissions, setPermissions } =
    props;
  const [scheduleCheck, setScheduleCheck] = useState();
  const [userCheck, setUserCheck] = useState();
  useEffect(() => {
    setPermissions({
      approve_schedule: user.permission?.includes("approve_schedule")
        ? true
        : false,
      delete_schedule: user.permission?.includes("delete_schedule")
        ? true
        : false,
      own_schedule: user.permission?.includes("own_schedule") ? true : false,
      view_schedule: user.permission?.includes("view_schedule") ? true : false,
      pay_schedule: user.permission?.includes("pay_schedule") ? true : false,
      create_schedule: user.permission?.includes("create_schedule")
        ? true
        : false,
      delete_users: user.permission?.includes("delete_users") ? true : false,
      manage_users: user.permission?.includes("manage_users") ? true : false,
      own_profile:
        user.permission?.includes("own_profile") == true ? true : false,
      view_users: user.permission?.includes("view_users") ? true : false,
    });
  }, [user]);
  useEffect(() => {
    setScheduleCheck(
      user.permission?.includes("approve_schedule") &&
        user.permission?.includes("delete_schedule") &&
        user.permission?.includes("own_schedule") &&
        user.permission?.includes("view_schedule") &&
        user.permission?.includes("create_schedule") &&
        user.permission?.includes("pay_schedule")
    );
    setUserCheck(
      user.permission?.includes("delete_users") &&
        user.permission?.includes("manage_users") &&
        user.permission?.includes("own_profile") &&
        user.permission?.includes("view_users")
    );
  }, [user, setPermissions, setScheduleCheck]);

  const handleScheduleChecked = () => {
    scheduleCheck == true ? setScheduleCheck(false) : setScheduleCheck(true);
    if (scheduleCheck) {
      setPermissions((preVal) => ({
        ...preVal,
        approve_schedule: false,
        delete_schedule: false,
        own_schedule: false,
        view_schedule: false,
        create_schedule: false,
        pay_schedule: false,
      }));
    }
    if (!scheduleCheck) {
      setPermissions((preVal) => ({
        ...preVal,
        approve_schedule: true,
        delete_schedule: true,
        own_schedule: true,
        view_schedule: true,
        create_schedule: true,
        pay_schedule: true,
      }));
    }
  };
  const handleUserChecked = () => {
    userCheck == true ? setUserCheck(false) : setUserCheck(true);
    if (userCheck) {
      setPermissions((preVal) => ({
        ...preVal,
        delete_users: false,
        manage_users: false,
        own_profile: false,
        view_users: false,
      }));
    }
    if (!userCheck) {
      setPermissions((preVal) => ({
        ...preVal,
        delete_users: true,
        manage_users: true,
        own_profile: true,
        view_users: true,
      }));
    }
  };
  return (
    <div>
      <Dialog open={open}>
        <DialogTitle>Permission</DialogTitle>
        <DialogContent>
          <Typography variant="body1" style={{ color: "#05234A" }}>
            <strong>Username:</strong> {user.userName}
          </Typography>
          <Typography variant="body1" style={{ color: "#05234A" }}>
            <strong>Full Name:</strong> {user.firstName} {user.lastName}
          </Typography>
          <Grid
            container
            spacing={1}
            style={{
              border: "1px solid #05234A",
              display: "block",
              marginTop: "10px",
              borderRadius: "15px",
            }}
          >
            <Grid item xs={12} style={{ display: "flex" }}>
              <Grid
                xs={7}
                style={{
                  alignItems: "center",
                  display: "flex",
                  margin: "10px",
                }}
              >
                {console.log("scheduleCheck", scheduleCheck)}
                <Checkbox
                  checked={
                    permissions?.own_schedule &&
                    permissions?.view_schedule &&
                    permissions?.approve_schedule &&
                    permissions?.delete_schedule
                  }
                  onChange={handleScheduleChecked}
                  name="scheduleManagement"
                  style={{ marginRight: "10px" }}
                />
                <Typography variant="h6">Schedule Management</Typography>
              </Grid>
              <Divider orientation="vertical" flexItem />
              <Grid
                xs={5}
                style={{
                  margin: "10px",
                  justifyContent: "center",
                  display: "block",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={permissions?.own_schedule}
                      onChange={() =>
                        setPermissions((prevValue) => ({
                          ...prevValue,
                          own_schedule: !permissions.own_schedule,
                        }))
                      }
                      name="own_schedule"
                      style={{ marginRight: "10px" }}
                    />
                  }
                  label="Own Schedule"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={permissions?.view_schedule}
                      onChange={() =>
                        setPermissions((prevValue) => ({
                          ...prevValue,
                          view_schedule: !permissions.view_schedule,
                        }))
                      }
                      name="view_schedule"
                      style={{ marginRight: "10px" }}
                    />
                  }
                  label="View Schedule"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={permissions?.approve_schedule}
                      onChange={() =>
                        setPermissions((preValue) => ({
                          ...preValue,
                          approve_schedule: !permissions.approve_schedule,
                        }))
                      }
                      name="approve_schedule"
                      style={{ marginRight: "10px" }}
                    />
                  }
                  label="Approve Schedule"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={permissions?.delete_schedule}
                      onChange={() =>
                        setPermissions((preValue) => ({
                          ...preValue,
                          delete_schedule: !permissions.delete_schedule,
                        }))
                      }
                      name="delete_schedule"
                      style={{ marginRight: "10px" }}
                    />
                  }
                  label="Delete Schedule"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={permissions?.create_schedule}
                      onChange={() =>
                        setPermissions((preValue) => ({
                          ...preValue,
                          create_schedule: !permissions.create_schedule,
                        }))
                      }
                      name="create_schedule"
                      style={{ marginRight: "10px" }}
                    />
                  }
                  label="Create Schedule"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={permissions?.pay_schedule}
                      onChange={() =>
                        setPermissions((preValue) => ({
                          ...preValue,
                          pay_schedule: !permissions.pay_schedule,
                        }))
                      }
                      name="pay_schedule"
                      style={{ marginRight: "10px" }}
                    />
                  }
                  label="Pay Schedule"
                />
              </Grid>
            </Grid>
            <Divider variant="middle" />
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Grid
                xs={7}
                style={{
                  alignItems: "center",
                  margin: "10px",
                  display: "flex",
                }}
              >
                <Checkbox
                  checked={
                    permissions?.own_profile &&
                    permissions?.view_users &&
                    permissions?.manage_users &&
                    permissions?.delete_users
                  }
                  onChange={handleUserChecked}
                  name="userManagement"
                  style={{ marginRight: "10px" }}
                />
                <Typography variant="h6">User Management</Typography>
              </Grid>
              <Divider orientation="vertical" flexItem />
              <Grid
                xs={5}
                style={{
                  margin: "10px",
                  justifyContent: "center",
                  display: "block",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={permissions?.own_profile}
                      onChange={() =>
                        setPermissions((preValue) => ({
                          ...preValue,
                          own_profile: !permissions?.own_profile,
                        }))
                      }
                      name="own_profile"
                      style={{ marginRight: "10px" }}
                    />
                  }
                  label="Own Profile"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={permissions?.view_users}
                      onChange={() =>
                        setPermissions((preValue) => ({
                          ...preValue,
                          view_users: !permissions.view_users,
                        }))
                      }
                      name="view_users"
                      style={{ marginRight: "10px" }}
                    />
                  }
                  label="View Users"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={permissions?.manage_users}
                      onChange={() =>
                        setPermissions((preValue) => ({
                          ...preValue,
                          manage_users: !permissions.manage_users,
                        }))
                      }
                      name="manage_users"
                      style={{ marginRight: "10px" }}
                    />
                  }
                  label="Manage Users"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={permissions?.delete_users}
                      onChange={() =>
                        setPermissions((preValue) => ({
                          ...preValue,
                          delete_users: !permissions.delete_users,
                        }))
                      }
                      name="delete_users"
                      style={{ marginRight: "10px" }}
                    />
                  }
                  label="Delete Users"
                />
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={handleClose}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleAgree}>
            Add Privilege
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default PermissionModel;
